export enum TutorialsActions {
    FETCH_VIEW = 'FETCH_VIEW',
    DOWNLOAD_TUTORIAL = 'DOWNLOAD_TUTORIAL',
    DELETE_TUTORIAL = 'DELETE_TUTORIAL',
    DELETE_VIDEO = 'DELETE_VIDEO',
}
